exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host ::ng-deep .dx-data-row > td:not(:nth-child(1)) {\n  padding-right: 7%;\n}\n@media (min-width: 1440px) {\n  :host ::ng-deep .dx-data-row > td:not(:nth-child(1)) {\n    padding-right: 17%;\n  }\n}\n.align {\n  -ms-flex-align: center;\n      align-items: center;\n}\n.transparent-btn {\n  min-width: 140px;\n}\n.date-month {\n  margin-top: 6px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/analitycs/analytics-table/analytics-table.component.less
// module id = ../../../../../src/app/members/application-management/analitycs/analytics-table/analytics-table.component.less
// module chunks = main